import { defineMessages } from 'react-intl';

export default defineMessages({
  UploadDocumentsTitle: {
    id: 'upload_documents_page.title',
  },
  UploadDocumentsSubTitle: {
    id: 'upload_documents_page.sub_title',
  },
  UploadDocumentsMyAutoSubTitle: {
    id: 'upload_documents_page.sub_title_myauto',
  },
  uploadDocumentsPageUploadDivTitle: {
    id: 'upload_documents_page.upload_div.title',
  },
  uploadDocumentsPageUploadDivSubTitle: {
    id: 'upload_documents_page.upload_div.sub_title',
  },
  uploadDocumentsPageUploadDivInput: {
    id: 'upload_documents_page.upload_div.input',
  },
  uploadDocumentBtn: {
    id: 'upload_documents_page.upload_document_btn',
  },
  uploadedDocument: {
    id: 'upload_documents_page.uploaded_document',
  },
  updateBtnLabel: {
    id: 'preopening_page.update.btn_label',
  },
  uploadButtonTitle: {
    id: 'upload_documents_page.upload_button_title',
  },
  UploadDocumentsBlocRecapTitle: {
    id: 'recap_page.documents_bloc_title',
  },
  errorUploadDocumentSizeAndType: {
    id: 'error.upload_document.pdf_upload_error',
  },
  UploadSupportDocumentTitle: {
    id: 'recap_page.support_document_title',
  },
  UploadPVDocumentTitle: {
    id: 'recap_page.pv_document_title',
  },
  support_document_cp: {
    id: 'identification_page.support_document_cp',
  },
  support_document_attestationDefinitive: {
    id: 'identification_page.support_document_attestationDefinitive',
  },
  uploadedDocuments: {
    id: 'manager_page.uploaded_documents',
  },
});
